export class ResponseCargueI{
  estado:string;
  mensaje:string;
  contenido:Array<any>;
}
